/**
 * AppFooter — footer strip rendered at the bottom of full-page
 * surfaces (Login, Home dashboard, admin pages). Ships the two-line
 * epi-guidelines compliance disclosure above the copyright line on
 * every authenticated host. Login opts out by passing
 * ``includeCompliance={false}`` — the disclosure is meaningless on
 * an unauthenticated surface and the PRD explicitly scopes it to
 * authenticated routes.
 *
 * Centralised so renaming / removing either line is a single edit.
 */
import React from 'react';

import ComplianceFooter from './ComplianceFooter';


export default function AppFooter({
  className = '',
  includeCompliance = true,
}: {
  /** Extra classes if the host wants to tweak spacing. */
  className?: string;
  /** Whether to render the epi-guidelines compliance disclosure above
   *  the copyright line. Default true — authenticated routes want it.
   *  Login / other unauthenticated surfaces pass false. */
  includeCompliance?: boolean;
}) {
  return (
    <div
      data-testid="app-footer-wrapper"
      className={'w-full ' + className}
    >
      {includeCompliance && <ComplianceFooter />}
      <footer
        data-testid="app-footer"
        className="w-full text-center text-[11px] text-zinc-400 py-4"
      >
        © Govind Kedia
      </footer>
    </div>
  );
}

